export const ACTIONS_ERROR = {
  ADD_PROPERTY_ERROR_PROPS: 'ADD_ERROR_PROPS',
  REMOVE_ALL_ERRORS: 'REMOVE_ALL_ERRORS',
};
